import { render, staticRenderFns } from "./settingProcess.vue?vue&type=template&id=01ce0e16&lang=pug"
import script from "./settingProcess.vue?vue&type=script&lang=js"
export * from "./settingProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports